import { lazy } from 'react';

import type { RouteConfig } from '../../types';

const DashboardLayout = lazy(() => import('@/layouts/DashboardLayout'));
const TasksLayout = lazy(() => import('@/pages/tasks/layout'));
const TasksListPage = lazy(() => import('@/pages/tasks'));
const TaskCreatePage = lazy(() => import('@/pages/tasks/create'));
const TaskUpdatePage = lazy(() => import('@/pages/tasks/update'));

/**
 * UG-4503 — task entity routes (legacy `app/(dashboard)/tasks/*`).
 * `TasksLayout` mounts the section breadcrumb; task DETAILS is a dialog on
 * the list (legacy `TaskDetailsModal`), not a page. Permissions:
 * `@/config/auth/routeAccess` (`/tasks` under the `tasks.view` subtree,
 * create/update under `tasks.manage` — ported 1:1 from the legacy table).
 */
export const taskRoutes: RouteConfig = {
  path: '/tasks',
  layout: DashboardLayout,
  children: [
    {
      path: '',
      layout: TasksLayout,
      children: [
        { path: '', element: TasksListPage },
        { path: '/create', element: TaskCreatePage },
        { path: '/:taskId/update', element: TaskUpdatePage },
      ],
    },
  ],
};
